<template>
    <div class="investment">
        <!-- <div class="top">
            <img @click="$router.go(-1)" class="left" src="../../assets/investment/left.png" alt="">
            <p class="right">{{getInvestmentTitle}}</p>
        </div> -->
        <router-view></router-view>

    </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex'
export default {
    name: "Investment",
    components: {},
    data() {
        return {
            
        };
    },
    computed: {
        ...mapGetters('investment', ['getInvestmentTitle'])
    },
    watch: {},
    methods: {
        ...mapActions('investment', [
            'getUnionAuth'
        ]),
    },
    created() {
        this.getUnionAuth().then(res=>{
            
        })
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.investment {
    width: 100%;
    min-height: 100%;
    background: #F5F6F9;
    box-sizing: border-box;
    // padding-bottom: 90px;
    font-family: PingFangSC-Regular;
    // padding-top: 56px;
    padding: env(safe-area-inset-bottom); /* zero for all rectangular user agents */
    padding: env(Safe-area-inset-bottom); /* 50px because UA properties are case sensitive */
    .top {
        background: #36B374;
        padding: 11px 20px;
        display: flex;
        justify-content: space-between;
        line-height: 22px;
        align-items: center;

        .left{
            width: 8px;
            height: 16px;
        }
        .right{
            flex-grow: 2;
            text-align: center;
            color: #FFFFFF;
            font-size: 16px;
        }
    }
}
/deep/.van-dropdown-menu__title::after{
    border-color: transparent transparent #999999 #999999;
    opacity: 1;
}
</style>